@if (datatransTransactionStatus !== '') {
    <div class="row">
        <div class="col-12">
            @switch (datatransTransactionStatus) {
                @case ('Success') {
                    <div class="alert alert-success" role="alert"
                         translate="epayment.success">
                    </div>
                }
                @case ('Revert') {
                    <div class="alert alert-danger" role="alert"
                         translate="epayment.revert">
                    </div>
                }
                @case ('Error') {
                    <div class="alert alert-danger" role="alert"
                         translate="epayment.error">
                    </div>
                }
                @case ('Cancel') {
                    <div class="alert alert-info" role="alert"
                         translate="epayment.cancel">
                    </div>
                }
            }
        </div>
    </div>
}

<!-- Warning Message to allow cam access  -->
@if ((qrCodeReaderEnabled && !hasPermission) || displayCameraAccessMessage) {
    <div class="row">
        <div class="col-12">
            <div class="alert alert-warning d-flex justify-content-start" role="alert"
                 translate="services.view.allowCamAccess">
            </div>
        </div>
    </div>
}

@if (!!service) {
    <div class="content-container">
        <!-- Title -->
        <div class="d-flex flex-row">
            <div class="title-container">
                <img src="{{ buildIconUrl(service.serviceConfig.iconUrl, 'gray') }}" alt="icon" height="40px"
                     width="auto">
                <h1>{{ service['name' + crtLang.toUpperCase()] }}</h1>
            </div>
            <div class="disponibility-container">
                <fa-icon class="circle" [icon]="faCircle"
                         [ngStyle]="{ 'color': service.active ? 'green' : 'orange' }"></fa-icon>
                <p class="service-disponibility"
                   [translate]="service.active ? 'services.view.available' : 'services.view.unavailable'"></p>
            </div>
        </div>

        <div class="btn-bar justify-content-start">
            @if (!cameraIsActivated && hasServiceEditAccess()) {
                <button class="btn btn-link" (click)="manageService()">
                    <fa-icon class="me-2" [icon]="faPen"></fa-icon>
                    <span translate="common.manageInfo"></span>
                </button>
            }
        </div>

        <!-- Action Buttons -->
        <div class="btn-bar">
            @if (canScanQrCode()) {
                <button class="btn btn-primary"
                        (click)="startQrCodeReader()"
                        translate="services.view.scan">
                </button>
            }
            @if (cameraIsActivated) {
                <button class="btn btn-outline-secondary"
                        (click)="stopQrCodeReader()"
                        translate="services.view.closeCam">
                </button>
            }
            @if (hasServiceAccessForServiceType(ServiceType.Wifi)) {
                <button class="btn btn-primary"
                        (click)="startBuyProcess()"
                        translate="services.view.purchase.purchasable">
                </button>
            }
            @if (canExportFalconicStatistic()) {
                <button class="btn btn-primary"
                        (click)="exportFalconicStatistics()"
                        translate="services.pottinger.actions.exportStatistics">
                </button>
            }
        </div>

        <!-- QRCode scanner -->
        @if (qrCodeReaderEnabled) {
            <div>
                <zxing-scanner [enable]="qrCodeReaderEnabled"
                               [formats]="[BarcodeFormat.QR_CODE]"
                               (scanSuccess)="scanSuccessHandler($event)"
                               (camerasFound)="camerasFoundHandler()"
                               (permissionResponse)="permissionResponse($event)">
                </zxing-scanner>
            </div>
        }

        <!-- Common Service Details -->
        <div class="row">
            <div class="col-12 col-lg-6">
                <div class="d-flex flex-column gap-3">
                    <!-- Description -->
                    @if (displayDescription) {
                        <div class="no-border-radius area-link"
                             [innerHTML]="service['description' + crtLang.toUpperCase()] | urlTextToLink">
                        </div>
                    }

                    <!-- Horaire -->
                    @if (lowestTariff?.nightRate) {
                        <div>
                            <h5 translate="services.tariff.schedule"></h5>
                            <p class="mb-0">{{
                                    'services.tariff.modal.dayRateInfo' | translate: {
                                        from: DateUtils.ngbTimeStructToString(DateUtils.stringToNgbTimeStruct(lowestTariff.nightRateTo), true),
                                        to: DateUtils.ngbTimeStructMinusOneMinuteToString(DateUtils.stringToNgbTimeStruct(lowestTariff.nightRateFrom))
                                    }
                                }}</p>
                            <p>{{
                                    'services.tariff.modal.nightRateInfo' | translate: {
                                        from: DateUtils.ngbTimeStructToString(DateUtils.stringToNgbTimeStruct(lowestTariff.nightRateFrom), true),
                                        to: DateUtils.ngbTimeStructMinusOneMinuteToString(DateUtils.stringToNgbTimeStruct(lowestTariff.nightRateTo))
                                    }
                                }}</p>
                        </div>
                    }

                    <!-- Tarif -->
                    @if (service.tariffs.length > 0 && (isCurrentBackofficeServiceExploitant() || hasRoleToAccessTheService())) {
                        <div>
                            <h5 translate="services.tariff.title"></h5>
                            @if (!!lowestTariff.customUnitFR) {
                                @for (price of lowestTariff?.tariffPrices; track price) {
                                    <p class="mb-0">
                                        @if (price.tariffConfigUnit) {
                                            {{ price.priceByUnit | currencyFormat }} / {{ 'common.units.' + price.tariffConfigUnit.unitEnumName + '.' + price.tariffConfigUnit.unitEnumValue | translate }}
                                            @if (price.nightRate) {
                                                <span>({{ 'services.tariff.modal.nightRate' | translate }})</span>
                                            }
                                        }
                                        @if (!price.tariffConfigUnit) {
                                            {{ price.priceByUnit | currencyFormat }} / {{ lowestTariff['customUnit' + crtLang.toUpperCase()] ? lowestTariff['customUnit' + crtLang.toUpperCase()] : lowestTariff.customUnitFR }}
                                            @if (price.nightRate) {
                                                <span>({{ 'services.tariff.modal.nightRate' | translate }})</span>
                                            }
                                        }
                                    </p>
                                }
                            }

                            @if (!lowestTariff.customUnitFR) {
                                @for (price of lowestTariff.tariffPrices; track price) {
                                    <p class="mb-0">
                                        {{ price.priceByUnit | currencyFormat }}
                                        / {{ 'common.units.' + price.tariffConfigUnit.unitEnumName + '.' + price.tariffConfigUnit.unitEnumValue | translate }}
                                        @if (price.nightRate) {
                                            <span>({{ 'services.tariff.modal.nightRate' | translate }})</span>
                                        }
                                    </p>
                                }
                            }
                        </div>
                    }

                    <!-- Availability Ranges -->
                    @if (service.availabilityRanges.length > 0) {
                        <div>
                            <h5 translate="services.view.availabilityRange.title"></h5>
                            @for (item of service.availabilityRanges; track item; let index = $index) {
                                <div class="mb-3">
                                    <!-- Availability Dates -->
                                    <p class="m-0">
                                        @if (!item.endDate) {
                                            <span>
                                                {{
                                                    'services.view.availabilityRange.sinceDate' | translate: {
                                                        startDate: (item.startDate | date: dateFormat)
                                                    }
                                                }}
                                            </span>
                                        } @else {
                                            <span>
                                                {{
                                                    'services.view.availabilityRange.fromToDate' | translate: {
                                                        startDate: (item.startDate | date: dateFormat),
                                                        endDate: (item.endDate | date: dateFormat)
                                                    }
                                                }}
                                            </span>
                                        }
                                    </p>

                                    <!-- Availability Days -->
                                    @if (item.days.length > 0) {
                                        <p class="m-0">
                                            {{ item.days | dayRangeFormat }}
                                        </p>
                                    }

                                    <!-- Availability Hours -->
                                    <p class="m-0">
                                        @if (item.startTime === '00:00:00' && item.endTime === '23:59:00') {
                                            <span>{{ 'services.view.availabilityRange.allDay' | translate }}</span>
                                        }
                                        @if (item.startTime !== '00:00:00' && item.endTime === '23:59:00') {
                                            <span>
                                                {{
                                                    'services.view.availabilityRange.sinceTime' | translate: {
                                                        startTime: formatTimeStringToDisplay(item.startTime)
                                                    }
                                                }}
                                            </span>
                                        }
                                        @if (item.startTime === '00:00:00' && item.endTime !== '23:59:00') {
                                            <span>
                                                {{
                                                    'services.view.availabilityRange.untilTime' | translate: {
                                                        endTime: formatTimeStringToDisplay(item.endTime)
                                                    }
                                                }}
                                            </span>
                                        }
                                        @if (item.startTime !== '00:00:00' && item.endTime !== '23:59:00') {
                                            <span>
                                                {{
                                                    'services.view.availabilityRange.fromToTime' | translate: {
                                                        startTime: formatTimeStringToDisplay(item.startTime),
                                                        endTime: formatTimeStringToDisplay(item.endTime)
                                                    }
                                                }}
                                            </span>
                                        }
                                    </p>
                                </div>
                            }
                        </div>
                    }

                    <!-- Measure points view-->
                    @if (hasServiceAccessForServiceType(ServiceType.TimeLimited)) {
                        <app-measuring-points-cockpit #measuringPointsCockpitComponent
                                                      (activateMeasuringPoint)="activateMeasuringPoint($event)"
                                                      [serviceId]="serviceId"
                                                      [isExploitant]="isCurrentBackofficeServiceExploitant()"></app-measuring-points-cockpit>
                    }

                    <!-- Charging Stations view-->
                    @if (hasServiceAccessForServiceType(ServiceType.ChargingStations) && service.active) {
                        <app-charging-stations-cockpit
                            [serviceId]="serviceId"
                            [isExploitant]="isCurrentBackofficeServiceExploitant()"></app-charging-stations-cockpit>
                    }

                    <!-- Koco Dumpster view-->
                    @if (hasServiceAccessForServiceType(ServiceType.WasteManagement)) {
                        <app-dumpster
                            [serviceId]="serviceId"></app-dumpster>
                    }
                </div>
            </div>

            <!-- Complementary Informations -->
            @if (displayInstruction || service.imageUrl) {
                <div class="col-12 col-lg-6 mt-lg-0 mt-4">
                    <div class="d-flex flex-column gap-3">
                        @if (displayInstruction) {
                            <div class="instructions-container">
                                <div class="logo-title-container">
                                    <img src="../assets/icons/information.svg" alt="icon" height="40px" width="auto"/>
                                    <h5><em
                                        translate>services.placeholder.{{ 'instruction' + crtLang.toUpperCase() }}</em>
                                    </h5>
                                </div>
                                <div class="no-border-radius area-link"
                                     [innerHTML]="service['instruction' + crtLang.toUpperCase()] | urlTextToLink">
                                </div>
                            </div>
                        }

                        @if (service.imageUrl) {
                            <img class="img-thumbnail"
                                 src="{{service.imageUrl}}" alt="Illustration">
                        }
                    </div>
                </div>
            }
        </div>
    </div>
}

@if (loggedIn && hasServiceAccessForServiceType(ServiceType.TimeLimited)
&& (isCurrentBackofficeServiceExploitant() || hasRole(AppRoles.customer))) {
    <app-activation-management #activationManagementComponent
                               [serviceId]="serviceId"
                               [isExploitant]="isCurrentBackofficeServiceExploitant()"></app-activation-management>
}

<!-- Energy view -->
@if (hasServiceAccessForServiceType(ServiceType.Energy)) {
    <app-energy [isExploitant]="isCurrentBackofficeServiceExploitant()"></app-energy>
}

<!-- Mooring place view -->
@if (hasServiceAccessForServiceType(ServiceType.MooringPlace)) {
    <app-mooring-place
        [serviceId]="serviceId"></app-mooring-place>
}

<!--Wifi view-->
@if (hasServiceAccessForServiceType(ServiceType.Wifi) && isCurrentBackofficeServiceExploitant()) {
    <app-wifi-subscription-list-for-exploitant [serviceId]="service.serviceId"></app-wifi-subscription-list-for-exploitant>
}
@if (hasServiceAccessForServiceType(ServiceType.Wifi) && !isCurrentBackofficeServiceExploitant()) {
    <app-wifi-subscription-list-for-customer></app-wifi-subscription-list-for-customer>
}

<!-- User Alarms view -->
@if (hasServiceAccessForServiceType(ServiceType.UserAlarm)) {
    <app-customer-alarm-amanagement
        [serviceId]="serviceId"
        [serviceActive]="service.active"
        [tariff]="lowestTariff"></app-customer-alarm-amanagement>
}

<!--Booking view-->
@if (hasAccessToBookingCockpit()) {
    <app-booking-cockpit
        [serviceId]="service.serviceId"
        [items]="service.items"
        [tariff]="lowestTariff"></app-booking-cockpit>
}

<!-- Craning view -->
@if (hasServiceAccessForServiceType(ServiceType.CraningAndWinterizing)) {
    <app-craning
        [service]="service"></app-craning>
}

<!-- Webcam view-->
@if (hasServiceAccessForServiceType(ServiceType.Webcam)) {
    <app-webcam></app-webcam>
}

<!-- Weather view-->
@if (hasServiceAccessForServiceType(ServiceType.Weather)) {
    <app-weather-cockpit
        [serviceId]="serviceId"></app-weather-cockpit>
}

<!-- Public Lighting view -->
@if (hasServiceAccessForServiceType(ServiceType.PublicLighting)) {
    <app-public-lighting
        [serviceId]="serviceId"></app-public-lighting>
}

<!-- Charging Process view -->
@if (hasAccessToChargingProcessManagement()) {
    <app-charging-process-management #chargingProcessManagementComponent
                                     [serviceId]="serviceId"
                                     [isExploitant]="isCurrentBackofficeServiceExploitant()"></app-charging-process-management>
}

<div class="content-container">
    <div class="btn-bar">
        <button class="btn btn-outline-secondary"
                (click)="back()" translate="common.back">
        </button>
    </div>
</div>

